import { Record } from 'immutable';

const RsvpRecord = Record({
  eventRsvpId: null,
  eventId: null,
  firstName: null,
  lastName: null,
  nights: null,
  roomRate: null,
  revenue: null,
  commission: null
});

export class Rsvp extends RsvpRecord {
  eventRsvpId: number;
  eventId: number;
  firstName: string;
  lastName: string;
  nights: number;
  roomRate: number;
  revenue: number;
  commission: number;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/rsvp.ts